export default __webpack_public_path__ + "static/media/Ashley_DeLuca_AHV_In_Moms_We_Trust.b9a54bc2.jpg";